import { gql } from '@apollo/client';

export const CREATE_OPPOSITION_BASE = gql`
mutation createOppositionBase($input: OppositionBaseInput!) {
  createOppositionBase(input: $input) {
    _id
    name
    description
    fileUrl
    active
  }
}
`;

export const UPDATE_OPPOSITION_BASE = gql`
mutation updateOppositionBase($input: UpdateOppositionBaseInput!) {
  updateOppositionBase(input: $input) {
    _id
    name
    description
    fileUrl
    active
  }
}
`;

export const REMOVE_OPPOSITION_BASE = gql`
mutation removeOppositionBase($input: String!) {
  removeOppositionBase(input: $input) {
    _id
  }
}
`;
